import { brandAssets } from '@echo/brand';
import mascotLost from '@echo/brand/assets/mascot-lost.png';
import { Button } from '@echo/ui-web';
import { Trans, useLingui } from '@lingui/react/macro';
import { Link } from '@tanstack/react-router';
import { EmptyStateArt, EmptyStateFrame } from './empty-state-frame';

/** Figma global/empty "Let's get you back on track": the page for an address that leads nowhere. */
export function NotFoundPage() {
  const { t } = useLingui();
  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-[840px] flex-col items-center px-gutter py-section-md">
      <EmptyStateFrame
        art={
          <EmptyStateArt
            src={mascotLost}
            alt={t`A cheerful brain character reading a map`}
            width={brandAssets.mascotLost.width}
            height={brandAssets.mascotLost.height}
          />
        }
        title={<Trans>Let's get you back on track</Trans>}
        actions={
          <Link to="/">
            <Button tabIndex={-1}>
              <Trans>Back to home</Trans>
            </Button>
          </Link>
        }
      >
        <Trans>
          We couldn't find the page you were looking for. Let's head back to Home, where you can
          choose what you'd like to do next.
        </Trans>
      </EmptyStateFrame>
    </main>
  );
}
